import { gql } from "@apollo/client";
import { AI_ROLE_BUILDER_TASK_FIELDS } from "graphql/fragments";

const DISCARD_AI_ROLE_BUILDER_TASK = gql`
  mutation DiscardAIRoleBuilderTask($input: DiscardAiRoleBuilderTaskInput!) {
    discardAiRoleBuilderTask(input: $input) {
      task {
        id
        status
        missionRoleId
      }
    }
  }
`;

const SUBMIT_AI_ROLE_BUILDER_JOB = gql`
  ${AI_ROLE_BUILDER_TASK_FIELDS}
  mutation SubmitAIRoleBuilderJob($input: SubmitAiRoleBuilderJobInput!) {
    submitAiRoleBuilderJob(input: $input) {
      task {
        ...AIRoleBuilderTaskFields
      }
    }
  }
`;

export { SUBMIT_AI_ROLE_BUILDER_JOB, DISCARD_AI_ROLE_BUILDER_TASK };
